import React, { useState } from "react";
import { Box, TextField, Button, Typography, Paper, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { recoverPassword } from "../../services/authService";

const Remember = () => {
  const [email, setEmail] = useState(""); 
  const [loading, setLoading] = useState(false); 
  const navigate = useNavigate();

  const handleEmailChange = (event) => {
    setEmail(event.target.value); 
  };

  const handleSubmit = async () => {
    if (!email) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor ingresa un correo.",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await recoverPassword(email);

      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Correo enviado",
          text: "Te hemos enviado un correo con las instrucciones para recuperar tu contraseña.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.message || "Hubo un error al intentar recuperar la contraseña.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text: error.message || "Error al conectar con el servidor. Intenta de nuevo.",
      });
    } finally {
      setLoading(false); 
    }
  };

  return (
    <Box
      sx={{
        background: "#a5b967",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <IconButton
        onClick={() => navigate("/login")}
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          backgroundColor: "white",
          color: "#a5b967",
          "&:hover": {
            backgroundColor: "#f0f0f0",
          },
        }}
      >
        <ArrowBackIosNewIcon fontSize="small" />
      </IconButton>

      <Box
        component={Paper}
        elevation={3}
        sx={{
          padding: 4,
          width: { xs: "90%", sm: 400 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 2,
          backgroundColor: "white",
        }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Recordar contraseña
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ marginBottom: 3 }}>
          Ingresa el correo correspondiente a la cuenta para recordar la contraseña.
        </Typography>

        <TextField
          fullWidth
          label="Correo electrónico"
          variant="outlined"
          sx={{ backgroundColor: "white", marginBottom: 2 }}
          value={email}
          onChange={handleEmailChange}
        />

        <Button
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#a5b967",
            "&:hover": { backgroundColor: "#8da253" },
            paddingY: 1.2,
            fontWeight: "bold",
          }}
          onClick={handleSubmit}
          disabled={loading} 
        >
          {loading ? "Enviando..." : "Enviar instrucciones"}
        </Button>
      </Box>
    </Box>
  );
};

export default Remember;
